import React, { Component } from "react";
import firebase from "../../utils/firebase";

import { Field } from "@atlaskit/form";
import { AvatarPickerDialog } from "@atlaskit/media-avatar-picker";
import Avatar from "@atlaskit/avatar";

import { InlineEditStateless } from "@atlaskit/inline-edit";
import SingleLineTextInput from "@atlaskit/input";

import "./profileFormProfile.css";
import { UserContext } from "../../Context";

const initState = {
  nameNew: "",
  phoneNumberNew: "",
  driversLicenseNew: "",
  occupationNew: "",
  birthdayNew: "",
  petsNew: "",
  facebookNew: "",
  linkedInNew: "",
  twitterNew: "",
  otherOccupantsNew: "",
  nameEditing: false,
  phoneNumberEditing: false,
  driversLicenseEditing: false,
  occupationEditing: false,
  birthdayEditing: false,
  petsEditing: false,
  facebookEditing: false,
  linkedInEditing: false,
  twitterEditing: false,
  otherOccupantsEditing: false
};
export default class ProfileFormProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initState,
      displayName:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.displayName
          ? this.props.userContext.my.displayName
          : "",
      phoneNumber:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.phoneNumber
          ? this.props.userContext.my.phoneNumber
          : "",
      driversLicense:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.driversLicense
          ? this.props.userContext.my.driversLicense
          : "",
      occupation:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.occupation
          ? this.props.userContext.my.occupation
          : "",
      birthday:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.birthday
          ? this.props.userContext.my.birthday
          : "",
      pets:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.pets
          ? this.props.userContext.my.pets
          : "",
      facebook:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.facebook
          ? this.props.userContext.my.facebook
          : "",
      linkedIn:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.linkedIn
          ? this.props.userContext.my.linkedIn
          : "",
      twitter:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.twitter
          ? this.props.userContext.my.twitter
          : "",
      otherOccupants:
        this.props.userContext &&
        this.props.userContext.my &&
        this.props.userContext.my.otherOccupants
          ? this.props.userContext.my.otherOccupants
          : ""
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.userContext.my &&
      props.userContext.my.displayName !== state.displayName
    )
      return { displayName: props.userContext.my.displayName };
    if (
      props.userContext.my &&
      props.userContext.my.phoneNumber !== state.phoneNumber
    )
      return { phoneNumber: props.userContext.my.phoneNumber };
    if (
      props.userContext.my &&
      props.userContext.my.driversLicense !== state.driversLicense
    )
      return { driversLicense: props.userContext.my.driversLicense };
    if (
      props.userContext.my &&
      props.userContext.my.occupation !== state.occupation
    )
      return { occupation: props.userContext.my.occupation };
    if (
      props.userContext.my &&
      props.userContext.my.birthday !== state.birthday
    )
      return { birthday: props.userContext.my.birthday };
    if (props.userContext.my && props.userContext.my.pets !== state.pets)
      return { pets: props.userContext.my.pets };
    if (
      props.userContext.my &&
      props.userContext.my.facebook !== state.facebook
    )
      return { facebook: props.userContext.my.facebook };
    if (
      props.userContext.my &&
      props.userContext.my.linkedIn !== state.linkedIn
    )
      return { linkedIn: props.userContext.my.linkedIn };
    if (props.userContext.my && props.userContext.my.twitter !== state.twitter)
      return { twitter: props.userContext.my.twitter };
    if (
      props.userContext.my &&
      props.userContext.my.otherOccupants !== state.otherOccupants
    )
      return { otherOccupants: props.userContext.my.otherOccupants };
    else return null;
  }

  onNameChangeHandler = e => this.setState({ nameNew: e.target.value });
  onPetsChangeHandler = e => this.setState({ petsNew: e.target.value });
  onFacebookChangeHandler = e => this.setState({ facebookNew: e.target.value });
  onLinkedInChangeHandler = e => this.setState({ linkedInNew: e.target.value });
  onTwitterChangeHandler = e => this.setState({ twitterNew: e.target.value });
  onOtherOccupantsChangeHandler = e =>
    this.setState({ otherOccupantsNew: e.target.value });
  onPhoneChangeHandler = e =>
    this.setState({
      phoneNumberNew: e.target.value
        .split("")
        .filter((v, i) => i < 10)
        .join("")
    });
  onDriversLicenseChangeHandler = e =>
    this.setState({
      driversLicenseNew: e.target.value
        .split("")
        .filter((v, i) => i < 15)
        .join("")
    });
  onOccupationChangeHandler = e =>
    this.setState({ occupationNew: e.target.value });
  onBirthdayChangeHandler = e => this.setState({ birthdayNew: e.target.value });
  handleAvatarPicker = () =>
    this.setState({ handleAvatarPicker: !this.state.handleAvatarPicker });

  handleAvatarFilePick = (file, crop) => console.log(file, crop);
  handleImagePickedDataURI = uri => {
    const formattedURI = uri.split(",")[1];
    const storageRef = firebase.storage().ref();
    const avatarRef = storageRef.child(
      `my/${this.props.userContext.user.uid}/photo`
    );

    // Base64url formatted string
    const uploadTask = avatarRef.putString(formattedURI, "base64", {
      customMetadata: {
        uid:
          this.props.userContext &&
          this.props.userContext.user &&
          this.props.userContext.user.uid
            ? this.props.userContext.user.uid
            : null
      },
      cacheControl: "public,max-age=86400",
      contentType: "image/jpg"
    });

    uploadTask.on(
      "state_changed",
      snapshot => {
        // Observe state change events such as progress, pause, and resume
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            console.log("default");
        }
      },
      error => {
        console.log(error);
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          firebase
            .firestore()
            .collection("my")
            .doc(this.props.userContext.user.uid)
            .update({
              photoURL: downloadURL
            })
            .then(result => {
              console.log(result);
              this.setState({ handleAvatarPicker: false });
            });
        });
      }
    );
  };

  cancel = item =>
    this.setState({ [`${item}New`]: "", [`${item}Editing`]: false });
  saveField = (key, value) => {
    this.setState({ [`${key}Saving`]: true });
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`${key}`]: !!value ? value : firebase.firestore.FieldValue.delete()
      })
      .then(() => this.setState(initState))
      .then(() => this.setState({ [`${key}Saving`]: false }))
      .catch(error => console.log(error));
  };

  formatPhoneNumber = number => {
    if (!number) return;
    return number
      .split("")
      .filter((num, i) => i < 10)
      .map((num, i) => {
        if (i === 0) return `(${num}`;
        if (i === 2) return `${num}) `;
        if (i === 5) return `${num}-`;
        else return num;
      })
      .join("");
  };

  formatDriversLicense = number => {
    if (!number) return;
    return number
      .split("")
      .filter((num, i) => i < 15)
      .map((num, i) => {
        if (i === 4) return `${num} - `;
        if (i === 9) return `${num} - `;
        else return num;
      })
      .join("");
  };

  render() {
    // console.log(this.state);
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="profile-form__profile">
            <Field className="profile-form__field" label="Photo">
              <Avatar
                appearance="square"
                size="xlarge"
                enableTooltip={true}
                onClick={this.handleAvatarPicker}
                name={"Choose Photo"}
                src={
                  userContext && userContext.my && userContext.my.photoURL
                    ? userContext.my.photoURL
                    : ""
                }
              />
            </Field>
            {this.state.handleAvatarPicker && (
              <AvatarPickerDialog
                title="Upload Photo"
                onImagePicked={this.handleAvatarFilePick}
                onImagePickedDataURI={this.handleImagePickedDataURI}
                avatars={[]}
                onCancel={this.handleAvatarPicker}
              />
            )}
            <hr />
            <Field
              className="profile-form__field"
              label={`Legal Name *`}
              shouldFitContainer={true}
            >
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.displayNameSaving}
                id="name"
                className="profile-form__field-text"
                name="name"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() => this.setState({ nameEditing: true })}
                onCancel={() => this.cancel("name")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("displayName", this.state.nameNew)
                }
                isEditing={this.state.nameEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.nameNew ||
                      this.state.displayName ||
                      "Your name goes here..."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("name");
                    }}
                    isFitContainerWidthReadView={true}
                    isEditing
                    isInitiallySelected
                    value={this.state.nameNew}
                    onChange={this.onNameChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="Phone Number">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.phoneNumberSaving}
                id="phoneNumber"
                className="profile-form__field-text"
                name="phoneNumber"
                type="tel"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() =>
                  this.setState({ phoneNumberEditing: true })
                }
                onCancel={() => this.cancel("phoneNumber")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("phoneNumber", this.state.phoneNumberNew)
                }
                isEditing={this.state.phoneNumberEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.formatPhoneNumber(this.state.phoneNumberNew) ||
                      this.formatPhoneNumber(this.state.phoneNumber) ||
                      "Your phone number goes here..."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("phoneNumber");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.phoneNumberNew}
                    onChange={this.onPhoneChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="Other Occupant">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.petsSaving}
                id="otherOccupants"
                className="profile-form__field-text"
                name="otherOccupants"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() =>
                  this.setState({ otherOccupantsEditing: true })
                }
                onCancel={() => this.cancel("otherOccupants")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("otherOccupants", this.state.otherOccupantsNew)
                }
                isEditing={this.state.otherOccupantsEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.otherOccupantsNew ||
                      this.state.otherOccupants ||
                      "Name of other occupants. Leave blank if not applicable."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("otherOccupants");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.otherOccupantsNew}
                    onChange={this.onOtherOccupantsChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="Pets">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.petsSaving}
                id="pets"
                className="profile-form__field-text"
                name="pets"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() => this.setState({ petsEditing: true })}
                onCancel={() => this.cancel("pets")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() => this.saveField("pets", this.state.petsNew)}
                isEditing={this.state.petsEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.petsNew ||
                      this.state.pets ||
                      "Do you have any pets? If so, describe. Leave blank if not applicable."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("pets");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.petsNew}
                    onChange={this.onPetsChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="Facebook">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.facebookSaving}
                id="pets"
                className="profile-form__field-text"
                name="facebook"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() => this.setState({ facebookEditing: true })}
                onCancel={() => this.cancel("facebook")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("facebook", this.state.facebookNew)
                }
                isEditing={this.state.facebookEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.facebookNew ||
                      this.state.facebook ||
                      "If you're happy to share a link to your facebook profile, please do so here."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("facebook");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.facebookNew}
                    onChange={this.onFacebookChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="LinkedIn">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.linkedInSaving}
                id="pets"
                className="profile-form__field-text"
                name="linkedIn"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() => this.setState({ linkedInEditing: true })}
                onCancel={() => this.cancel("linkedIn")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("linkedIn", this.state.linkedInNew)
                }
                isEditing={this.state.linkedInEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.linkedInNew ||
                      this.state.linkedIn ||
                      "If you're happy to share a link to your LinkedIn profile, please do so here."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("linkedIn");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.linkedInNew}
                    onChange={this.onLinkedInChangeHandler}
                  />
                }
              />
            </Field>
            <hr />
            <Field className="profile-form__field" label="Twitter">
              <InlineEditStateless
                shouldConfirmOnEnter
                isWaiting={this.state.twitterSaving}
                id="pets"
                className="profile-form__field-text"
                name="twitter"
                type="text"
                shouldFitContainer={true}
                isFitContainerWidthReadView={true}
                onEditRequested={() => this.setState({ twitterEditing: true })}
                onCancel={() => this.cancel("twitter")}
                isConfirmOnBlurDisabled={true}
                onConfirm={() =>
                  this.saveField("twitter", this.state.twitterNew)
                }
                isEditing={this.state.twitterEditing}
                isInitiallySelected
                readView={
                  <SingleLineTextInput
                    isFitContainerWidthReadView={true}
                    className="profile-form__inline-field-view"
                    isEditing={false}
                    value={
                      this.state.twitterNew ||
                      this.state.twitter ||
                      "If you're happy to share a link to your Twitter profile, please do so here."
                    }
                  />
                }
                editView={
                  <SingleLineTextInput
                    onCancel={() => {
                      this.cancel("twitter");
                    }}
                    isEditing
                    isInitiallySelected
                    value={this.state.twitterNew}
                    onChange={this.onTwitterChangeHandler}
                  />
                }
              />
            </Field>
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}

ProfileFormProfile.defaultProps = {
  userContext: {
    my: {}
  }
};

// {
// <hr />
//   <Field
//     className="profile-form__field"
//     label="Drivers License Number"
//   >
//     <InlineEditStateless
//       isWaiting={this.state.driversLicenseSaving}
//       id="driversLicense"
//       className="profile-form__field-text"
//       name="driversLicense"
//       type="text"
//       shouldFitContainer={true}
//       isFitContainerWidthReadView={true}
//       onEditRequested={() =>
//         this.setState({ driversLicenseEditing: true })
//       }
//       onCancel={() => this.cancel("driversLicense")}
//       isConfirmOnBlurDisabled={true}
//       onConfirm={() =>
//         this.saveField("driversLicense", this.state.driversLicenseNew)
//       }
//       isEditing={this.state.driversLicenseEditing}
//       isInitiallySelected
//       readView={
//         <SingleLineTextInput
//           isFitContainerWidthReadView={true}
//           className="profile-form__inline-field-view"
//           isEditing={false}
//           value={
//             this.formatDriversLicense(this.state.driversLicenseNew) ||
//             this.formatDriversLicense(this.state.driversLicense) ||
//             "Your drivers license number goes here..."
//           }
//         />
//       }
//       editView={
//         <SingleLineTextInput
//           onCancel={() => {
//             this.cancel("driversLicense");
//           }}
//           isEditing
//           isInitiallySelected
//           value={this.state.driversLicenseNew}
//           onChange={this.onDriversLicenseChangeHandler}
//         />
//       }
//     />
//   </Field>
//   <hr />
//   <Field className="profile-form__field" label="Occupation">
//     <InlineEditStateless
//       isWaiting={this.state.occupationSaving}
//       id="occupation"
//       className="profile-form__field-text"
//       name="occupation"
//       type="text"
//       shouldFitContainer={true}
//       isFitContainerWidthReadView={true}
//       onEditRequested={() =>
//         this.setState({ occupationEditing: true })
//       }
//       onCancel={() => this.cancel("occupation")}
//       isConfirmOnBlurDisabled={true}
//       onConfirm={() =>
//         this.saveField("occupation", this.state.occupationNew)
//       }
//       isEditing={this.state.occupationEditing}
//       isInitiallySelected
//       readView={
//         <SingleLineTextInput
//           isFitContainerWidthReadView={true}
//           className="profile-form__inline-field-view"
//           isEditing={false}
//           value={
//             this.state.occupationNew ||
//             this.state.occupation ||
//             "Write your occupation here..."
//           }
//         />
//       }
//       editView={
//         <SingleLineTextInput
//           onCancel={() => {
//             this.cancel("occupation");
//           }}
//           isEditing
//           isInitiallySelected
//           value={this.state.occupationNew}
//           onChange={this.onOccupationChangeHandler}
//         />
//       }
//     />
//   </Field>
//   <hr />
//   <Field className="profile-form__field" label="Date of Birth">
//     <InlineEditStateless
//       isWaiting={this.state.birthdaySaving}
//       id="birthday"
//       className="profile-form__field-text"
//       name="birthday"
//       type="text"
//       shouldFitContainer={true}
//       isFitContainerWidthReadView={true}
//       onEditRequested={() => this.setState({ birthdayEditing: true })}
//       onCancel={() => this.cancel("birthday")}
//       isConfirmOnBlurDisabled={true}
//       onConfirm={() =>
//         this.saveField("birthday", this.state.birthdayNew)
//       }
//       isEditing={this.state.birthdayEditing}
//       isInitiallySelected
//       readView={
//         <SingleLineTextInput
//           isFitContainerWidthReadView={true}
//           className="profile-form__inline-field-view"
//           isEditing={false}
//           value={
//             this.state.birthdayNew ||
//             this.state.birthday ||
//             "Write your birthday here..."
//           }
//         />
//       }
//       editView={
//         <SingleLineTextInput
//           onCancel={() => {
//             this.cancel("birthday");
//           }}
//           isEditing
//           isInitiallySelected
//           value={this.state.birthdayNew}
//           onChange={this.onBirthdayChangeHandler}
//         />
//       }
//     />
//   </Field>}



// WEBPACK FOOTER //
// ./src/components/profileFormProfile/ProfileFormProfile.js